<template>
	<div class="containerMain">
		<i class="fas fa-arrow-left"></i><title-bar :topTitle="true" topTitleText="Formación" class="mb-4"/>
		<title-bar v-if="school" :title="school.name" class="mb-4"/>
		<div class="col inner" v-if="synthesis" >
			<div style="width: 100%;">
				<div class="mb-4">
					<p>{{`Realizada el ${getHumanDateAndTime(synthesis.date)}`}}</p>
				</div>

				<div class="mb-4" v-if="!school">
					<h2>Colegio</h2>
					<p>{{synthesis.school.name}}</p>
				</div>

				<div class="mb-4">
					<h2>Coach</h2>
					<p>{{getPersonFullName(synthesis.coach)}}</p>
				</div>

				<div class="mb-4">
					<h2>Tipo</h2>
					<p v-if="synthesis.data.formationType">{{isForTeachers ? 'Capacitación' : 'Plática para padres'}}</p>
					<p v-else>Capacitación</p>
				</div>

				<div class="mb-4" v-if="this.trainingTalk">
					<h2>Formación</h2>
					<p v-if="trainingTalk.title">{{trainingTalk.title}}</p>
					<p v-else>Capacitación</p>
				</div>

				<div class="mb-4" v-if="synthesis.data.name">
					<h2>Título </h2>
					<table class="table table-sm table-striped">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="3" type="text" name="description" v-model="synthesis.data.name" :disabled="true"/></td>
						</tr>
					</table>
				</div>

				<div class="mb-4" v-show="synthesis.data.formationSpeaker">
					<h2>Ponente</h2>
					<p>{{synthesis.data.formationSpeaker}}</p>
				</div>

				<div class="mb-4" v-if="synthesis.data.academicLevels">
					<h2>Niveles </h2>
					<table class="table table-sm table-striped">
						<tr v-for="(item, index) in synthesis.data.academicLevels" v-if="item" :key="`levels${index}`">
							<td><p class="text-justify">{{item.name}}</p></td>
						</tr>
					</table>
				</div>

				<div class="mb-4" v-if="synthesis.data.languages">
					<h2>Idiomas </h2>
					<table class="table table-sm table-striped">
						<tr v-for="(item, index) in synthesis.data.languages" v-if="item" :key="`languages${index}`">
							<td><p class="text-justify">{{item.name}}</p></td>
						</tr>
					</table>
				</div>

				<div class="mb-4">
					<h2>Especificaciones </h2>
					<table class="table table-sm table-striped" v-if="synthesis.data.specifications">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="3" type="text" name="specifications" v-model="synthesis.data.specifications" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['synthesisId', 'schoolId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		synthesis () {
			if (!this.$store.state.admin.synthesis) return null;
			let synthesis = this.$store.state.admin.synthesis;
			let type = typeof synthesis.data;
			if (type !== 'object') synthesis.data = JSON.parse(synthesis.data);
			return synthesis;
		},
		school () {
			if (!this.$store.state.admin.schools) return null;
			if (!this.schoolId) return null;
			return this.$store.state.admin.schools.find((school) => (school.schoolId == this.schoolId));
		},
		isForTeachers () {
			return !this.synthesis.data.formationType ||
			this.synthesis.data.formationType == 'forTeachers' ||
			this.synthesis.data.formationType == 2;
		},
		trainingTalk () {
			if (!this.synthesis.data.coachingTalkTypeId) return null;
			if (!this.$store.state.admin.trainingTalks) return null;
			return this.$store.state.admin.trainingTalks.find((talk) => {
				return talk.id == this.synthesis.data.coachingTalkTypeId;
			});
		}
	},
	methods: {
		getHumanDateAndTime (date) {
			return helpers.dateTime.getHumanDateAndTime(date);
		},
		getPersonFullName (person) {
			return helpers.persons.getPersonFullName(person);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/TrainingDetail.vue